var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCornerTwoFrame1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 285,
    viewBox: "0 0 400 285",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M142.401 159.613H336.4C371.024 159.613 399.093 187.682 399.093 222.307C399.093 256.931 371.024 285 336.4 285H204.355C170.139 285 142.401 257.263 142.401 223.047V159.613Z",
    fill: "#007580"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M273.707 79.7186L336.4 79.7186L399.094 79.7186C399.094 114.343 371.025 142.412 336.4 142.412C301.776 142.412 273.707 114.343 273.707 79.7186Z",
    fill: "#FF7F50"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M273.707 62.6935L336.4 62.6935L399.094 62.6935C399.094 28.0688 371.025 2.45385e-06 336.4 5.48084e-06C301.776 8.50782e-06 273.707 28.0688 273.707 62.6935Z",
    fill: "#60C2A5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.000223401 222.123L62.6933 222.123L125.387 222.123C125.387 256.748 97.3179 284.816 62.6932 284.816C28.0686 284.816 -0.000226428 256.748 -0.000223401 222.123Z",
    fill: "#60C2A5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M267.788 136.496L205.095 136.496L142.401 136.496C142.401 101.872 170.47 73.8027 205.095 73.8027C239.719 73.8027 267.788 101.872 267.788 136.496Z",
    fill: "#284993"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCornerTwoFrame1);
export default __webpack_public_path__ + "static/media/CornerTwoFrame1.8a58112e933492a4be92daa4aee7e74b.svg";
export { ForwardRef as ReactComponent };